import PropTypes from 'prop-types';
import React from 'react';
import './index.scss';

const AddActionBar = ({ setState, disable, child }) => {
  return (
    <div>
      <span
        className={`text-${disable} desktop-d4 cursor-${!disable ? 'not-allowed' : 'pointer'}`}
        onClick={() => setState(true)}
      >
        {child}
      </span>
    </div>
  );
};

AddActionBar.propTypes = {
  setState: PropTypes.func.isRequired,
  disable: PropTypes.bool.isRequired,
  child: PropTypes.string.isRequired,
};
export default AddActionBar;
